import { TherapistAction } from "src/redux/actions/constant";

const intialState: object = {
    response: null,
    isGetTherapistDicipline: false,
    data: [],
    loading: false,
};

export const therapistDiciplineReducer = (state = intialState, action: any) => {
    switch (action.type) {
        case TherapistAction.GET_ALL_THERAPIST_DICIPLINE_TYPE_SUCCESS: {
            return {
                ...state,
                response: action.payload,
                isGetTherapistDicipline: true,
                data: action.payload.data,
                loading: false,
            };
        }
        case TherapistAction.GET_ALL_THERAPIST_DICIPLINE_TYPE_FAILURE: {
            return {
                ...state,
                response: action.payload,
                isGetTherapistDicipline: false,
                loading: false,
            };
        }
        case TherapistAction.GET_ALL_THERAPIST_DICIPLINE_TYPE_REQUEST:
            return {
                ...state,
                loading: true,
            };

        default:
            return state;
    }
};
